import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAppContext } from '../../context/AppContext';

function AuthenticatedOutlet() {
  const { isAuthenticated } = useAppContext();
  const location = useLocation();

  return isAuthenticated ? (
    <>
      <Outlet />
    </>
  ) : (
    <Navigate
      to={{
        pathname: '/login',
        search:
          '?' +
          new URLSearchParams({
            redirect: `${location.pathname}${location.search}`,
          }).toString(),
      }}
    />
  );
}

export default AuthenticatedOutlet;
